/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reviewMaterial.vue?vue&type=template&id=597b5883&scoped=true&"
import script from "./reviewMaterial.vue?vue&type=script&lang=js&"
export * from "./reviewMaterial.vue?vue&type=script&lang=js&"
import style0 from "./reviewMaterial.vue?vue&type=style&index=0&id=597b5883&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597b5883",
  null
  
)

export default component.exports